import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Constants } from '../shared/constants';
import { Observable } from 'rxjs';
import { ServiceAndProductMappingCountModel } from '../shared/models/service-and-product-mapping-count.model';

@Injectable({ providedIn: 'root' })
export class ServiceAndProductMappingCountService {
  private token = localStorage.getItem('token');
  private headers = new HttpHeaders({ 'Content-Type': 'application/json', Authorization: 'Bearer ' + this.token });

  private url = Constants.devServerEndpoint + 'api/serviceandproductmappingcountbyuser';
  constructor(private httpClient: HttpClient) {}

  public getServiceAndProductMappingCountByUser(): Observable<ServiceAndProductMappingCountModel[]> {
	return this.httpClient.get<ServiceAndProductMappingCountModel[]>(this.url + `/getServiceAndProductMappingCountByUser/`, { headers: this.headers });
  }
}
